import { asyncLoadRouter } from '@router/helper'

const organizations = [
  {
    path: 'organizations',
    component: asyncLoadRouter('manager/accounts/Organizations'),
    meta: {
      breadcrumb: (i18n) => [
        {
          text: i18n.t('activerecord.models.organization.other'),
          to: { name: 'manager-accounts-organizations' },
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'manager-accounts-organizations',
        component: asyncLoadRouter('manager/accounts/organizations/List'),
        meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.list') }] },
      },
    ],
  },
]

export default organizations
